import { Pipe, PipeTransform } from '@angular/core';

@Pipe({
  name: 'filter'
})

export class FilterPipe implements PipeTransform {

  transform(items: any[], searchText: string, prop: string = ''): any {
    if (!items || !searchText) return items

    searchText = this.removeAccentuation(searchText.toLowerCase())

    if (searchText && searchText.length > 2) {
      if (prop) {
        return items.filter(item => {
          const value = prop ? item[prop] : item
          return this.removeAccentuation(value.toString().toLowerCase()).includes(searchText)
        })
      } else {
        return this.filterByValue(items, searchText.trim())
      }
    } else {
      return items
    }
  }

  removeAccentuation(value) {
    return value.normalize('NFD').replace(/[\u0300-\u036f]/g, '')
  }

  filterByValue(array, value) {
    return array.filter(o =>
      Object.keys(o).some(k => {
        if (typeof value == 'string') {
          value = this.removeAccentuation(value.toLowerCase())
        }

        if (typeof o[k] == 'string' || typeof o[k] == 'number') {
          return this.removeAccentuation(o[k].toString().toLowerCase()).includes(value)
        } else if (o[k] != undefined) {
          return this.removeAccentuation(JSON.stringify(o[k]).toLowerCase()).includes(value)
        } else if (typeof o != undefined) {
          return this.removeAccentuation(JSON.stringify(o).toLowerCase()).includes(value)
        }
      })
    )
  }
}